<div class="confirm-dialog-container">
  <div class="icon-section">
    <div class="warning-icon">!</div>
  </div>

  <div class="message-section">
    <h3>Are you sure?</h3>
    <p>
      This action will unmap the service from this environment, affecting new deployments.
      Would you like to continue?
    </p>
  </div>

  <div class="button-section">
    <button class="cancel-btn" (click)="onCancel()">Cancel</button>
    <button class="confirm-btn" (click)="onConfirm()">Yes, Continue</button>
  </div>
</div>